import { observable, action } from 'mobx';

import { ConnectionAppManager, Variables } from 'core/index';

import { ProfilesApp } from 'apps/profile/app';
import { ProfilesQuery } from 'apps/profile/gql';

import i18next from 'i18next';

export class ProfileConnManager extends ConnectionAppManager {
  static ArrayApp = ProfilesApp;
  @observable sortBy;
  @observable sortOptions;
  constructor(parent, init, options) {
    super(parent, init, options);
    this.initialBatchSize =
      init.initialBatchSize || this.arrayApp.cardLayout.initialBatchSize;

    this.sortBy = init.sortBy || '-followers';
    this.sortOptions = init.sortOptions || [
      ['-followers', i18next.t('Followers')],
      ['recent', i18next.t('Recent')],
    ];
    this.batchSize = init.batchSize || 8;
    this.filterBy = init.filterBy || [];
    this.contains = init.contains || '';
    this.whitelabels = init.whitelabels || [];
    this.variables = new Variables({
      space: () => {
        if (this.manager) {
          return this.manager.variables.space || '';
        }
        return '';
      },
      slug: () => {
        if (this.manager) {
          return this.manager.variables.slug || '';
        }
        return '';
      },
      sortBy: () => this.sortBy,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
      filterBy: () => this.filterBy,
      contains: () => this.contains,
      whitelabels: () => this.whitelabels,
    });
    this.loadMoreQuery = init.loadMoreQuery || ProfilesQuery;
  }

  @action NewSlug = () => {
    this.Reset();
  };

  @action SetSort = sort => {
    this.sortBy = sort;
    this.Clear();
    this.loadMore();
  };
}
